import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessOperatorService {
  public readonly REALTOR = 1;    //不動産会社
  public readonly FINANCIAL = 2;  //金融機関
  public readonly OFFICE = 3;     //運営事務所

  constructor(
    private http: MiraieService,
  ) { }


	getBusiness(type) {
		var url = "business/get";
    let param = { type };
		return this.http.post(url, param);
	}

	insertBusiness(business) {
		var url = "business/insert";

		return this.http.post(url, business);
	}
}
